import { render, staticRenderFns } from "./common-center-dialog-v2.vue?vue&type=template&id=111147d2&scoped=true&"
import script from "./common-center-dialog-v2.vue?vue&type=script&lang=js&"
export * from "./common-center-dialog-v2.vue?vue&type=script&lang=js&"
import style0 from "./common-center-dialog-v2.vue?vue&type=style&index=0&id=111147d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111147d2",
  null
  
)

export default component.exports